import React from "react";
import { toast, ToastPosition } from "react-toastify";
import { AppDispatch } from "../../../../redux/store";
import { setActivePersonalChat } from "../../store/chatActions";
import { ChatMessage } from "../../types";
import { ToastMessage } from "./ToastMessage";

const optionsToast = () => {
  return {
    position: "bottom-right" as ToastPosition,
    rtl: true,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    closeButton: false,
    draggable: true,
    theme: "",
    progress: undefined,
    bodyClassName: "p-0 m-0",
    className: "p-0 mx-4 my-2 overflow-visible",
  };
};

export const handleClickNotify =
  (userInfoId: string, message: ChatMessage) => (dispatch: AppDispatch) => {
    return dispatch(
      setActivePersonalChat(userInfoId, String(message.senderId), message._id)
    );
  };

export const notifyToast = ({ userInfoId, message, photofile }) => {
  toast(
    (dismiss) => (
      <ToastMessage
        userInfoId={userInfoId}
        message={message}
        photofile={photofile}
        closeToast={dismiss?.closeToast}
      />
    ),
    optionsToast()
  );
};
